import { escapeHTML } from '../../utils/escape.js';

/**
 * Toggle de publi para el panel de staff. Función de render pura: devuelve
 * un string HTML, sin estado ni efectos. Muestra el estado actual
 * (ACTIVADA / DESACTIVADA) y un botón que lleva `data-action="publi-toggle"`
 * con `data-next` indicando el valor a setear al clickear.
 *
 * @param {boolean} enabled — estado actual del flag
 * @returns {string} HTML del toggle
 */
export const PubliToggle = (enabled) => {
    const stateLabel = enabled ? 'ACTIVADA' : 'DESACTIVADA';
    const next = enabled ? 'false' : 'true';
    const toggleLabel = enabled ? 'Desactivar' : 'Activar';
    const safeNext = escapeHTML(next);

    return `
        <div class="flex items-center justify-between gap-4 py-4 border-b border-border-subtle">
            <span class="text-text-primary">Publicidad: <span class="font-bold">${escapeHTML(stateLabel)}</span></span>
            <button data-action="publi-toggle" data-next="${safeNext}"
                class="px-4 py-2 rounded-xl border border-border-subtle text-xs font-black uppercase tracking-widest text-text-muted hover:text-brand transition-colors">
                ${escapeHTML(toggleLabel)}
            </button>
        </div>
    `;
};
